import React from 'react';
import { useParams } from 'react-router-dom';
import PaymentSuccess from '../components/payments/PaymentSuccess';

function PaymentSuccessPage() {
    const { uid } = useParams(); // Token from URL
    // Force status to 'approved' for success page
    return <PaymentSuccess token={uid} forcedStatus="approved" />;
}

export default PaymentSuccessPage;
